export default [ `en-US`, `sv-SE`, `da-DK`, `no-NO` ]
